import React, { ChangeEvent, useEffect, useState } from 'react';
import {
	FormGroup,
	InputDate,
	InputTextArea,
	InputTextblock,
	Layout,
} from '../../../components';
import DynamicFaIcon from '../../../components/atoms/DynamicFaIcon';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Tevent, initialEvent } from '../../../type/event';
import {
	getDataDetailUniqueId,
	uploadAttendEvent,
} from '../../../service/eventService';
import Lottie from 'lottie-react';
import successAnimation from '../../../assets/lotties/animation-success.json';
import { convertToInputDate } from '../../../utls/date';
import { showMessage } from '../../../utls/message';
import InputNumberBlock from '../../../components/atoms/InputNumberblock';
import useDisableNumberInputScroll from '../../../utls/inputNumber';

const AttendQR = () => {
	const navigate = useNavigate();
	const [event, setEvent] = useState<Tevent>(initialEvent);
	const [startDate, setStartDate] = useState<Date | undefined>();
	const [feedback, setFeedback] = useState<string | undefined>();
	const [sales, setSales] = useState<string | undefined>();
	const [onSubmit, setOnSubmit] = useState(false);
	const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

	const { slug } = useParams();

	// disable scrolling in number inputs
	useDisableNumberInputScroll();

	const navigator = useNavigate();

	const getDataNewsDetail = async (slug: string) => {
		const response = await getDataDetailUniqueId(slug);

		if (!response?.error) {
			setEvent(response?.data);
		}

		const startDate = convertToInputDate(response?.data.startDate);
		setStartDate(new Date(startDate));
	};

	const handleSubmit = async () => {
		const formData = new FormData();
		formData.append('id', event.id?.toString() || '');
		formData.append('feedback', feedback ? feedback : '');
		formData.append('sales', sales ? sales : '');

		if (selectedFiles && selectedFiles.length) {
			for (let i = 0; i < selectedFiles.length; i++) {
				formData.append('image', selectedFiles[i]);
			}
		}

		const response = await uploadAttendEvent(formData);
		if (response?.code === 200) {
			if (event.questionnaireSlug) {
				navigate(`/admin/events/${slug}/questioner/${event.questionnaireSlug}`);

				return;
			}

			navigate(`/admin`);
		} else {
			showMessage(response?.message, 'error');
		}
	};

	const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
		// Get the selected files from the input element
		const files = event.target.files;
		if (files) {
			// Convert FileList to Array
			const filesArray = Array.from(files);
			// Update the state with the selected files
			setSelectedFiles([...selectedFiles, ...filesArray]);
		}
	};

	useEffect(() => {
		if (slug) {
			getDataNewsDetail(slug);
		}
	}, []);

	return (
		<>
			{onSubmit && (
				<div className="mx-auto !max-w-[480px]">
					<div className="z-[99999] fixed !max-w-[480px] h-full w-full overflow-hidden bg-[#1C274C] opacity-[86%]"></div>
					<div className="z-[99999] fixed !max-w-[480px] h-full w-full overflow-hidden flex flex-col items-center justify-center">
						<Lottie
							animationData={successAnimation}
							className="w-[268px]"
						/>
						<h1 className="text-white text-[18px] font-bold">
							File berhasil diupload
						</h1>
						<button
							className="flex items-center gap-4 my-8"
							onClick={() => navigator(`/admin/events/all`)}
						>
							<img
								src="/assets/imgs/icon-arrow-left.svg"
								alt=""
							/>
							<p className="text-[16px] text-white">Back to home</p>
						</button>
					</div>
				</div>
			)}
			<Layout
				showNavBar={false}
				showNavigation={true}
			>
				<div className="mb-[7rem] mt-5 min-h-screen overflow-auto">
					<h1 className="text-base font-bold">Form Kegiatan</h1>

					<div className="mt-[20px]">
						<FormGroup label={'Judul / Tema Kegiatan'}>
							<InputTextblock
								readOnly
								value={event?.name}
								placeholder="Tuliskan judul/tema dari kegiatan"
							/>
						</FormGroup>
						<FormGroup label={'Lokasi'}>
							<InputTextblock
								readOnly
								value={event?.location}
								placeholder="Tuliskan lokasi kegiatan"
							/>
						</FormGroup>
						<FormGroup label={'Tanggal Kegiatan'}>
							<InputDate
								startDate={startDate ? startDate : new Date()}
								onChange={(date) => {
									setStartDate(date);
								}}
								disabled
							/>
						</FormGroup>
						<FormGroup label={'Saran & Testimoni'}>
							<InputTextArea
								value={feedback}
								onChange={(e) => {
									setFeedback(e.target.value);
								}}
								placeholder="Berikan saran & testimoni dari kagiatan ini"
							/>
						</FormGroup>
						<FormGroup label={'Omzet bulan sebelumnya'}>
							<InputNumberBlock
								value={event?.sales}
								onChange={(e) => {
									setSales(e.target.value);
								}}
								placeholder="Tuliskan omzet bulan sebelumnya"
							/>
						</FormGroup>
						<FormGroup label={'Dokumentasi Kegiatan'}>
							<div className="relative flex items-center justify-center w-full col-span-2 px-[30px]">
								<label
									htmlFor="dropzone-file"
									className="z-[1] w-full h-[157px] border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800  hover:bg-gray-100"
								>
									<div className="h-full flex flex-col items-center justify-center px-5 text-center gap-4">
										<img
											src="/assets/imgs/icon-upload.svg"
											alt="upload icon"
										/>
										{/* <FaCloudUploadAlt className="text-[32px] text-gray-500" /> */}
										<p className="text-[12px]">
											<span className="text-[#1A64C3]">Pilih file </span>
											dokumentasi yang akan diunggah, <br />
											<span className="text-gray-600">
												pilih gambar atau video
											</span>
										</p>
									</div>
								</label>
								<input
									id="dropzone-file"
									className="absolute"
									type="file"
									onChange={handleFileChange}
									multiple
								/>
							</div>

							{selectedFiles.length > 0 && (
								<div className="my-4">
									<p>Selected files:</p>
									<ul className="text-[12px]">
										{selectedFiles.map((file, index) => (
											<li key={index}>{file.name}</li>
										))}
									</ul>
								</div>
							)}
						</FormGroup>

						<div className="my-5 flex justify-between gap-4 px-[30px]">
							<button className="w-full px-[44px] py-[12px] text-[13px] rounded-[8px] hover:opacity-80 text-white bg-gray-700">
								Cancel
							</button>
							<button
								className="w-full px-[44px] py-[12px] text-[13px] rounded-[8px] hover:opacity-80 text-white bg-[#156CF7]"
								onClick={() => handleSubmit()}
							>
								Upload
							</button>
						</div>
					</div>
				</div>
			</Layout>
		</>
	);
};

export default AttendQR;
